import { Grid as MuiGrid } from '@mui/material';
import { spacing, spacingBase } from '../../theme/tokens';
import type { SpacingToken } from '../../theme/tokens';
import type { GridProps as MuiGridProps } from '@mui/material/Grid';

type GridItemSize = number | 'auto' | 'grow' | false;

export type GridProps = Omit<MuiGridProps, 'spacing' | 'gap'> & { gap?: SpacingToken };

export const LayoutGrid = ({ gap = 'md', children, sx, ...rest }: GridProps): JSX.Element => (
  <MuiGrid
    container
    spacing={spacing[gap] / spacingBase}
    sx={[{ minWidth: 0 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    {...rest}
  >
    {children}
  </MuiGrid>
);

export type GridItemProps = Omit<MuiGridProps, 'size' | 'gap' | 'spacing' | 'container'> & {
  xs?: GridItemSize;
  sm?: GridItemSize;
  md?: GridItemSize;
  lg?: GridItemSize;
  xl?: GridItemSize;
};

export const LayoutGridItem = ({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  sx,
  ...rest
}: GridItemProps): JSX.Element => (
  <MuiGrid
    size={{ xs, sm, md, lg, xl }}
    sx={[{ minWidth: 0 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    {...rest}
  >
    {children}
  </MuiGrid>
);
